// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191759/js/" + chunkId + "." + {"44":"53a8032a","225":"c7a434b1","481":"a197437a","486":"4d076fd2","770":"31fd18c8"}[chunkId] + ".0.7679140381528311.chunk.js";
};